module.exports = __webpack_public_path__ + "static/Upload b&w_mobile-9b699f263347c0d75bf1fcad2e95bf25.gif";